import user from './user';
import admin from './admin';
import torrent from './torrent';

const api = {
  user,
  admin,
  torrent
};

export default () => { return api; };
